module.exports = __webpack_public_path__ + "static/holly-infinite-zoom-86be2c793d8c40ac3bf78a6729b810c4.jpg";